module.exports = __webpack_public_path__ + "static/media/background.481526f0.jpg";